import { RichText } from "@atlassiansox/bxp-content-framework";

import { Container, Row, Column, Stack } from "../../components";
import { UiAnimatedHeroSectionModel } from "../../models";
import { renderViewModel, renderViewModels } from "../../render-view-model";
import { BackgroundField } from "../../styles";

import { Labels } from "./components/Labels";
import {
    DesktopImageColumnA,
    DesktopImageColumnB,
    DesktopWave,
    MobileImages,
    MobileWave,
    Section,
    Wrapper
} from "./UiAnimatedHeroSection.styles";

type UiAnimatedSectionHeroProps = {
    model: UiAnimatedHeroSectionModel;
};

const UiAnimatedHeroSection = ({
    model: {
        content: { content, background, callsToAction, images, labels }
    }
}: UiAnimatedSectionHeroProps) => {
    const imagesDoubled = [
        ...images.content.items,
        ...images.content.items
    ].map(
        //prevent duplicate key errors
        (image, index) => ({ ...image, id: `${image.id}-${index}` })
    );
    return (
        <Wrapper>
            <Section background={background as BackgroundField[]}>
                <MobileWave
                    height="31"
                    preserveAspectRatio="none"
                    viewBox="0 0 428 31"
                    width="428"
                >
                    <path d="M0 31h428V0C204.857 53.535 199.059-31.763 0 27.14V31Z" />
                </MobileWave>
                <Container>
                    <Row>
                        <Column
                            xs={{ top: "outerspace" }}
                            lg={{ align: "left", span: "6" }}
                        >
                            <RichText document={content} />
                            {callsToAction && (
                                <Stack spacing="compact">
                                    {renderViewModels(callsToAction)}
                                </Stack>
                            )}
                            <MobileImages>
                                {renderViewModel(images)}
                            </MobileImages>
                        </Column>
                        <DesktopImageColumnA>
                            {renderViewModels(imagesDoubled)}
                        </DesktopImageColumnA>
                        <DesktopImageColumnB>
                            {renderViewModels(imagesDoubled.reverse())}
                        </DesktopImageColumnB>
                        <Labels options={labels} />
                    </Row>
                </Container>
                <DesktopWave
                    height="99"
                    preserveAspectRatio="none"
                    viewBox="0 0 1440 99"
                    width="1440"
                >
                    <path d="M0 99h1440V0C689.239 179.5 669.733-106.498 0 91v8Z" />
                </DesktopWave>
            </Section>
        </Wrapper>
    );
};

export default UiAnimatedHeroSection;
